import breadCrumb from './breadCrumb'

export default breadCrumb
